import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-cardlogo',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './cardlogo.component.html',
  styleUrl: './cardlogo.component.css'
})
export class CardlogoComponent {
  @Input() cardName: string | undefined;

  get cardNameToShow(): string | undefined {
    if (!this.cardName) return undefined;
    return this.cardName?.toLocaleLowerCase();
  }
}
